import type { ReactNode } from 'react';

import './page.css';

/** Props for `PageHeader`. */
export interface PageHeaderProps {
  /** The page's one `<h1>`. */
  title: string;
  /** A short line above the title, in sage (for example the area or a status). */
  eyebrow?: ReactNode;
  /** One or two sentences under the title. */
  description?: ReactNode;
  /** The page's actions; at most one of them primary. */
  actions?: ReactNode;
}

/**
 * The top of a page: its `<h1>`, a description and its actions. Every page
 * has exactly one.
 *
 * @example
 * <PageHeader title="Your profile" description="Schools see this once it is live." actions={<Button variant="primary">Preview</Button>} />
 */
export function PageHeader({ title, eyebrow, description, actions }: PageHeaderProps) {
  return (
    <header className="page-header">
      {eyebrow ? <p className="page-header__eyebrow">{eyebrow}</p> : null}
      <div className="page-header__row">
        <div className="page-header__text">
          <h1>{title}</h1>
          {description ? <p className="page-header__description">{description}</p> : null}
        </div>
        {actions ? <div className="page-header__actions">{actions}</div> : null}
      </div>
    </header>
  );
}
